import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import type { PublicationItemInfo } from "./useTaskDetailSubscription";
import type { PreviewSibling } from "./useTaskDetailActions";
import { ArticleVariations } from "./ArticleVariations";
import type { ArticleInfo } from "./AnchorsSection";

export function ArticleBand(props: {
  article: ArticleInfo;
  publicationItems: PublicationItemInfo[] | null;
  onViewVariation: (variationId: string, siblings: PreviewSibling[]) => void;
}) {
  const { article } = props;

  return (
    <TableRow>
      <TableCell
        colSpan={3}
        sx={{ pt: 0.5, pb: 1, pl: 4, pr: 2, borderBottom: "none" }}
      >
        <Box
          sx={{
            bgcolor: "action.hover",
            borderRadius: 1,
            px: 1.5,
            py: 1,
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            display="block" mb={article.variations.length > 0 ? 0.75 : 0}
          >
            {article.spintaxTitle}
          </Typography>
          <ArticleVariations
            variations={article.variations}
            publicationItems={props.publicationItems}
            onViewVariation={props.onViewVariation}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}
